import FilterStatusIndicatorController from "./filter_status_indicator_controller";

export default class extends FilterStatusIndicatorController {
  shouldShowIndicator() {
    return this.element.querySelector("input:checked");
  }
}
